$(document).ready(function() {
    var newsTicker,
        isMobile = window.innerWidth <= 767;

    if (isMobile) {
        var slider = $(".testimonial-slider")[0],
            isDragging = false,
            startPosition = 0,
            scrollStart = 0,
            velocity = 0,
            momentumID = null;

        function animateMomentum() {
            // Slowly reduce velocity
            if (Math.abs(velocity) > 0.5) {
                slider.scrollLeft += velocity;
                velocity *= 0.95; // Decay factor
                momentumID = requestAnimationFrame(animateMomentum);
            } else {
                cancelAnimationFrame(momentumID);
                momentumID = null;
                newsTicker && newsTicker.start();
            }
        }

        slider.addEventListener("touchstart", function(e) {
            isDragging = true;
            startPosition = e.touches[0].clientX;
            scrollStart = slider.scrollLeft;
            velocity = 0;
            if (momentumID) cancelAnimationFrame(momentumID);
            newsTicker && newsTicker.stop();
        }, { passive: false });

        slider.addEventListener("touchmove", function(e) {
            if (isDragging) {
                e.preventDefault(); // Prevent page scroll
                var currentX = e.touches[0].clientX;
                var delta = startPosition - currentX;
                slider.scrollLeft = scrollStart + delta;
                velocity = (slider.scrollLeft - scrollStart); // Track speed
            }
        }, { passive: false });

        slider.addEventListener("touchend", function() {
            isDragging = false;
            animateMomentum(); // Launch smooth momentum
        });

        slider.addEventListener("mousedown", function(e) {
            isDragging = true;
            startPosition = e.clientX;
            scrollStart = slider.scrollLeft;
            velocity = 0;
            if (momentumID) cancelAnimationFrame(momentumID);
            newsTicker && newsTicker.stop();
        });

        slider.addEventListener("mousemove", function(e) {
            if (isDragging) {
                e.preventDefault();
                var currentX = e.clientX;
                var delta = startPosition - currentX;
                slider.scrollLeft = scrollStart + delta;
                velocity = (slider.scrollLeft - scrollStart);
            }
        });

        slider.addEventListener("mouseup", function() {
            isDragging = false;
            animateMomentum();
        });

        slider.addEventListener("mouseleave", function() {
            if (isDragging) {
                isDragging = false;
                animateMomentum();
            }
        });
    }

    newsTicker = $(".testimonial-slider").ticker({
        speed: isMobile ? 0 : 50,
        pauseOnHover: true,
        item: ".three-column-cards-col"
    }).data("ticker");
});
